import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { MasterLayout } from '@/templates'

@Component({
  components: { MasterLayout },
})
export default class HomeMaster extends Vue {}
